import React, { useState } from 'react';
import {CardBody, Col, Form, FormGroup, Input, Label, Row} from 'reactstrap';
import Switch from "react-bootstrap-switch";
import {useForm} from "react-hook-form";
import {connect, useSelector} from "react-redux";
import {getStateByPath} from "../../../redux/selectors";

// labels
import {
    FL_ONLY_REGISTERED,
} from "../../../components/i18n/formLabels";

// actions
import {setFilter} from "../../../redux/actions/generics/IndexedActions";

// components
import { ButtonClean, ButtonSearch} from "../../../components/buttons/buttonsActions";


function ParamSettingsFilters(props) {
    const componentState = useSelector(state => getStateByPath(state, props.path));
    const { path } = componentState;
    const { filter, app } = componentState?.data;

    const [onlyRegistered, setOnlyRegistered] = useState(!props.generalPropouse);

    // ----------------------------------------------
    //            SEARCH FILTERS FORM
    // ----------------------------------------------
    const {register, handleSubmit, reset} = useForm({
        defaultValues:{
            ps_key: filter?.ps_key ,
            ps_value_max: filter?.ps_value_max
        }
    });

    const onSubmit = (data, _) => {
        let dataFilter = {}

        if (!props.generalPropouse) {
            if(!app?.fbDataBase?.id)
                return

            dataFilter =  {
                fbDataBase : { id : app?.fbDataBase?.id },
                onlyRegistered : onlyRegistered,
                item : {
                    ...data,
                }
            };
        } else {
            dataFilter = {
                onlyRegistered : false,
                item : {
                    ...data,
                }
            };
        }

        props.setFilter(path, dataFilter);
    };

    const cleanFields = () => {
        reset();
    }

    return (
        <Form onSubmit={handleSubmit(onSubmit)}>
            <CardBody className="">
                <Row>
                    <Col md="4">
                        <FormGroup>
                            <Label>Llave</Label>
                            <Input type="text" name="ps_key"
                                   placeholder="Búsqueda por llave"
                                   innerRef={register}
                            />
                        </FormGroup>
                    </Col>
                    <Col md="6">
                        <FormGroup>
                            <Label>Valor</Label>
                            <Input type="text" name="ps_value_max"
                                   placeholder="Búsqueda por valor"
                                   innerRef={register}
                            />
                        </FormGroup>
                    </Col>
                    <Col md="2">
                        <FormGroup>
                            <Label>{ FL_ONLY_REGISTERED }</Label>
                            <br/>
                            <Switch
                                animate={true}
                                offText={"No"}
                                onText={"Si"}
                                value={onlyRegistered}
                                disabled={app?.fbDataBase === undefined}
                                onChange={ () => setOnlyRegistered(!onlyRegistered) }
                            />
                        </FormGroup>
                    </Col>
                </Row>
                <Row>
                    <Col md="12" className="d-flex justify-content-center">
                        <div className="float-right">
                            <ButtonSearch/>
                            <ButtonClean onClick={() => cleanFields()}/>
                        </div>
                    </Col>
                </Row>
        </CardBody>
        </Form>
    )
}

const mapStateToProps = _ => ({
})

const mapActionsToProps = ({
    setFilter,
})

export default connect(mapStateToProps, mapActionsToProps)(ParamSettingsFilters)
